import {appName} from '../settings/constants'


const localAppDataKey = 'app'
const _getAppKey = () => `${appName}-${localAppDataKey}`


export const getLocalAppData = () => {
    let app
    try {
        app = JSON.parse(localStorage.getItem(_getAppKey()))
    } catch (e) {return null}
    return app;
}

export const setLocalAppData = (data) => {
    let current = getLocalAppData()
    if (!current) current = {}
    let result = {}
    for (let key in data) {
        if (typeof data[key] === 'undefined') continue
        result[key] = data[key]
    }
    localStorage.setItem(_getAppKey(), JSON.stringify({
        ...current,
        ...data
    }))
}

export const clearLocalAppData = () => localStorage.setItem(_getAppKey(), JSON.stringify(null))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/helpers/localData.js